import React, { useEffect, useRef, useState } from "react";
import { Button, Empty } from "antd";

import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import WhiteSpacePieChart from "./WhiteSpacePieChart";
import WhiteSpaceBarChartStacked from "./WhiteSpaceBarChartStacked";
import { getModuleCode } from "../../../../utils/oneintelligence/OneIntelligenceHelper";
import WhiteSpaceServices from "../../../../services/WhiteSpace.services";
import { setWhitespacePieList, setWhitespacePieValues } from "../../../../store/components/Reports.slice";
import RenderComponent from "../../../General/RenderComponent"
import TrackFeatureServices from "../../../../services/TrackFeature.services";

function WhiteSpacePieChartItem({
    data,
    isMacro,
    showZeroInChart,
    clickBar
}) {
    const dispatch = useDispatch();
    const pieContRef = useRef();
    const [isLoadingPie, setIsLoadingPie] = useState(false);
    const [itemCount, setItemCount] = useState(0);
    const [noData, setNoData] = useState(false);
    const [pieData, setPieData] = useState([]);
    const { whitespacePieList } = useSelector((state) => state.reports);
    const {
        configuration: {
            buildedTargets
        }
    } = useSelector((state) => state.marketExplorer);

    const moduleCode = getModuleCode();

    const getPieData = (itemObj) => {
        if (!buildedTargets.length) return;
        setIsLoadingPie(true);
        setNoData(false);
        
        const { commonParams } = TrackFeatureServices.getMonitor({featureKey:"whitespaceRunDeepDive"})
        WhiteSpaceServices.getRelations(itemObj, commonParams).then((resp) => {
            dispatch(setWhitespacePieValues({
                key: itemObj.path,
                value: {
                    path: itemObj.path,
                    title: itemObj.title,
                    value: resp
                }
            }));
            setPieData(resp);
            setIsLoadingPie(false);
        });
    };

    useEffect(() => {
        getPieData(data);
    }, [data, buildedTargets]);

    useEffect(() => {
        if (!pieData.reduce((acc, d) => {
            acc += d.score;
            return acc;
        }, 0)) {
            setNoData(true);
        } else {
            setNoData(false);
        }
    }, [pieData]);

    const chartTitle = () => {
        const { name } = data;
        return name;
    };

    const onChangeItemCount = (count) => {
        setItemCount(count);
    };

    return (
        <div
            className="whitespace-chartWithClose"
            name={`${data.name}_pieChart`}
            style={{
                width: isMacro ? "100%" : "49%",
                height: "auto",
                border: "1px solid #E2E8F0",
                padding: "2mm",
                paddingTop: "5mm",
                borderRadius: "3px",
                backgroundColor: "white"
            }}
        >
            <span style={{ padding: "3mm" }} className="fs-18 fw-600 c-bg-700">{chartTitle()}</span>
            <Button
                className="whitespace-chartWithClose-close"
                type="link"
                icon={<CloseOutlined className="whitespace-chartWithClose-icon" />}
                danger
                title="Remove"
                onClick={() => {
                    const [catpath] = data.path.split("/");
                    dispatch(setWhitespacePieList({
                        key: catpath,
                        value: whitespacePieList[catpath].filter((d) => d.path !== data.path)
                    }));
                }}
            />
            {/* <p style={{ padding: "2mm", textAlign: "justify" }}>{isLoadingPieText ? <Skeleton active /> : pieDetails}</p> */}
            <div
                className={`flex-1 d-flex ${itemCount < 15 ? "align-items-center" : "align-items-start"} ${(isMacro ? "justify-content-between" : "justify-content-center")}`}
                style={{
                    height: "100%"
                }}
            >
                {moduleCode !== "brandloyalty" && <div
                    ref={pieContRef}
                    className="d-flex-col justify-content-center align-items-center"
                    style={{
                        width: !isMacro ? "120mm" : "130mm",
                        height: !isMacro ? "120mm" : "145mm",
                        paddingTop: "7mm",
                        marginTop: itemCount < 15 ? "0" : "10%",
                        paddingBottom: !isMacro ? 0 : "3mm"
                    }}
                >
                    <RenderComponent
                        isFullscreen
                        loadingProps={{
                            loading: isLoadingPie,
                            description: "Loading Chart. Please wait..."
                        }}
                    >
                        <WhiteSpacePieChart
                            data={pieData}
                            noData={noData}
                            upperCase={moduleCode !== "healthcareclaims"}
                        />
                        {isMacro && <span className="fs-16 fw-400 c-bg-700">Share of Consideration</span>}
                    </RenderComponent>
                </div>}
                {isMacro && !data.isDeepdive && (
                    <WhiteSpaceBarChartStacked
                        onChangeItemCount={onChangeItemCount}
                        clickBar={moduleCode === "brandloyalty" ? undefined : clickBar}
                        data={data}
                        showZeroInChart={showZeroInChart}
                    />
                )}
            </div>
        </div>
    );
}

export default WhiteSpacePieChartItem;
